<template>
    <div class="info-page-container hidden-first">

        <div class="info-inner-container">
            <section class="container">
                <div class="row-custom">
                    <div class="team-col">
                        <h1>Facturering via Infomedics</h1>
                        <p>
                            Bij Tandzorg Gestel maken wij gebruik van Infomedics voor de afhandeling van onze facturen. Deze professionele samenwerkingspartner zorgt ervoor dat alle administratieve processen rondom uw behandeling soepel verlopen.
                        </p>    
                        <p>
                            <strong>Voordelen van Infomedics facturering:</strong>
                        </p>
                        <ul class="infomedics-benefits">
                            <li>✓ Directe afhandeling met uw zorgverzekeraar</li>
                            <li>✓ Overzichtelijke en duidelijke facturen</li>
                            <li>✓ Snelle verwerking van declaraties</li>
                            <li>✓ Professionele klantenservice</li>
                            <li>✓ Veilige gegevensverwerking</li>
                        </ul>
                        <p>
                            Na uw behandeling krijgt u een overzichtelijke factuur van Infomedics, waarin duidelijk staat wat er bij uw zorgverzekeraar gedeclareerd is en welk bedrag u eventueel zelf dient te betalen. Dit geeft u volledige transparantie over de kosten.
                        </p>
                        <p>
                            <strong>Digitale facturering:</strong><br>
                            Standaard ontvangt u uw factuur digitaal per e-mail. Dit is milieuvriendelijk, snel en gemakkelijk te bewaren. Heeft u een voorkeur voor een papieren rekening? Dan kunt u dit eenvoudig doorgeven aan onze praktijk, zodat wij dit voor u kunnen regelen.
                        </p> 
                        <p>
                            <strong>Contact Infomedics:</strong><br>
                            <span class="contact-details">
                                <strong>Website:</strong> <a href="https://www.infomedics.nl" target="_blank" class="infomedics-link">www.infomedics.nl</a><br>
                                <strong>Telefoon:</strong> <a href="tel:+31362031900" class="contact-link">036 - 20 31 900</a><br>
                                <strong>E-mail:</strong> <a href="mailto:info@infomedics.nl" class="contact-link">info@infomedics.nl</a>
                            </span>
                        </p>
                        <p>
                            Heeft u vragen over uw rekening, betaling of andere administratieve zaken? Het vriendelijke team van Infomedics helpt u graag verder tijdens kantooruren.
                        </p>
                    </div>
                    <div class="team-col" id="tarieven">
                        <h1>Tarieven</h1>
                        <p>
                            De tarieven voor tandheelkundige behandelingen worden in Nederland jaarlijks landelijk vastgesteld door de Nederlandse Zorgautoriteit (NZa). Via de volgende link kunt u de actuele, wettelijk bepaalde tarieven bekijken: <b><a href="https://puc.overheid.nl/nza/doc/PUC_789284_22/1/" target="_blank" class="tarieven-url">https://puc.overheid.nl/nza/doc/PUC_789284_22/1/</a></b>
                        </p>
                        <p>
                            Zo bent u altijd goed geïnformeerd over de kosten van uw behandeling en komt u niet voor verrassingen te staan.
                        </p>
                    </div>
                </div>
            </section>
            <section class="container second-info-container">
                <div class="row-custom">
                    <div class="team-col">
                        <h1>Huisregels</h1>
                        <p>
                            Om een prettige en veilige ervaring te garanderen voor zowel onze patiënten als ons team, hanteren wij een aantal huisregels. Wij vragen uw begrip en medewerking om elk bezoek zo aangenaam mogelijk te maken.
                            <ol class="house-rules-list">
                                <li>
                                    <b>Persoonlijke gegevens</b><br>
                                    <p>Als nieuwe patiënt verzoeken wij u om bij de eerste afspraak een geldig legitimatiebewijs en uw verzekeringspasje mee te nemen.</p>
                                    <p>Veranderingen in uw gezondheidstoestand en medicijngebruik horen wij graag voorafgaand aan uw afspraak.</p>
                                    <p>Wij streven ernaar wachttijden zo kort mogelijk te houden. Mocht dit onverhoopt niet lukken, vragen wij om uw begrip.</p>
                                </li>
                                <li>
                                    <b>Afspraak maken en annuleren</b><br>
                                    <p>Alle afspraken dienen minimaal 24 uur van tevoren te worden geannuleerd. Dit geeft ons de mogelijkheid om de vrijgekomen tijd aan andere patiënten aan te bieden.</p>
                                    <p>Bij het niet tijdig annuleren van uw afspraak of bij te laat komen, kunnen wij genoodzaakt zijn om de gereserveerde tijd in rekening te brengen.</p>
                                    <p>Wij streven ernaar wachttijden zo kort mogelijk te houden. Mocht dit onverhoopt niet lukken, vragen wij om uw begrip.</p>
                                </li>
                                <li>
                                    <b>Spoedgevallen</b><br>
                                    <p>Heeft u pijnklachten? Neem dan zo snel mogelijk contact op met onze praktijk. Als u vóór 10.00 uur belt, doen wij ons best u dezelfde dag nog te helpen.</p>
                                    <p>Buiten openingstijden kunt u voor spoedeisende tandheelkundige hulp terecht bij de spoeddienst (Mondzorg Poli ‘s-Hertogenbosch, 0900-1515). Deze dienst is uitsluitend bedoeld voor spoedgevallen.</p>
                                    <p>Bij minder dringende klachten proberen wij u zo snel mogelijk in te plannen. Soms kan dit door drukte niet dezelfde dag.</p>
                                </li>
                                <li>
                                    <b>Behandelingen</b><br>
                                    <p>Tijdens uw eerste bezoek maken wij uitgebreid kennis en voeren wij een mondonderzoek uit. Indien nodig maken we röntgenfoto’s om een volledig beeld van uw gebitssituatie te krijgen.</p>
                                    <p>Op basis van dit onderzoek bespreken we samen met u de bevindingen en eventuele behandelmogelijkheden.</p>
                                    <p>Tijdens de reguliere halfjaarlijkse controle is er doorgaans geen tijd voor uitgebreide behandelingen. Indien nodig wordt een vervolgafspraak ingepland.</p>
                                </li>
                            </ol>
                        </p>
                        <p>Heeft u vragen over onze huisregels of wilt u meer informatie? Neem gerust contact met ons op. Wij helpen u graag verder!</p>
                    </div>
                </div>
            </section>
        </div>
</div>

</template>

<script>
export default {
    name: "Info",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show-first')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden-first')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Praktijk Informatie | Tandzorg Gestel | Openingstijden & Tarieven"
      document.querySelector('meta[name="description"]').setAttribute("content", "Praktische informatie over Tandzorg Gestel: openingstijden, tarieven, verzekeringen, locatie en wat u kunt verwachten bij uw bezoek.");
      this.$store.commit('updateActivePage', 'Info')
    }

}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}
.show-first {
  opacity: 1;
  transform: translateX(0);
}
.info-page-container {
  margin-top: 88px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 2rem 0;
}

.info-inner-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.row-custom {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
}
.team-col {
    flex-basis: 48%;
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}
.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
}
.team-col p {
    padding: 5px 0 0;
    font-size: 1.4rem;
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
}

.second-info-container {
    /* background-color: red; */
    align-self: start;
    padding: 0rem 2rem 6rem 2rem;
    margin-top: -50px;
}

.house-rules-list {
    padding: 0;
    padding-left: 0;
    font-size: 1.4rem;
    margin-top: 20px;
    margin-bottom: 13px;
}

.house-rules-list li {
    background-color: #f9f9f9;
    padding: 1.5rem;
    margin-bottom: 20px;
    border-radius: 8px;
    border-left: 4px solid var(--blue);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    list-style: none;
}

.house-rules-list li b {
    color: var(--blue);
    font-size: 1.6rem;
    display: block;
    margin-bottom: 0.5rem;
}

.house-rules-list li p {
    margin-bottom: 8px;
    line-height: 1.6;
    color: #333;
}
.tarieven-url {
    color: #0066cc;
    text-decoration: underline;
    transition: color 0.3s ease;
}

.tarieven-url:hover {
    color: #004499;
}

.infomedics-benefits {
    background-color: #f8f9fa;
    padding: 1.5rem;
    border-radius: 8px;
    border-left: 4px solid var(--blue);
    margin: 1rem 0;
    list-style: none;
}

.infomedics-benefits li {
    padding: 0.5rem 0;
    font-size: 1.4rem;
    color: #2c3e50;
}

.contact-details {
    background-color: #e3f2fd;
    padding: 1rem;
    border-radius: 6px;
    display: inline-block;
    margin-top: 0.5rem;
    border: 1px solid #bbdefb;
}

.infomedics-link {
    color: #0066cc;
    text-decoration: underline;
}

.infomedics-link:hover {
    color: #004499;
}

.team-col {
    background-color: #ffffff;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    margin-bottom: 2rem;
    border: 1px solid #e0e0e0;
}

.team-col h1 {
    color: var(--blue);
    border-bottom: 3px solid var(--blue);
    padding-bottom: 0.5rem;
    margin-bottom: 1.5rem;
}

.team-col p {
    line-height: 1.8;
    margin-bottom: 1rem;
}

@media(max-width: 991px) {
    .info-page-container {
    margin-top: 55px;
    }
    .row-custom {
        display: flex;
        flex-direction: column;
        row-gap: 0px;
        margin-bottom: 20px;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }
    #tarieven {
        margin-top:20px;
    }
    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
    }

    .second-info-container {
    padding: 0rem 2rem 0rem 2rem;
    }
    .second-info-container {
        margin-top: -25px;
    }

}
</style>
